import coreIconLabMetadata from '@atlaskit/icon-lab/metadata';

import { getIconName } from './get-icon-name';
import { type NewCoreIconData } from './types';

// get core icons info as a Promise which returns a Record
export const getIconLabCoreIcons: () => Promise<void | {
	[x: string]: NewCoreIconData;
}> = () => {
	return Promise.all(
		Object.keys(coreIconLabMetadata).map(async (name: string) => {
			const icon = await import(
				/* webpackChunkName: "@atlaskit-internal_[request]" */ `@atlaskit/icon-lab/core/${name}`
			);
			return { name, icon: icon.default };
		}),
	)
		.then((newData) =>
			newData
				.map((icon) => {
					const metadata = coreIconLabMetadata[icon.name];
					return {
						[icon.name]: {
							key: icon.name,
							keywords: metadata.keywords,
							component: icon.icon,
							componentName: metadata.componentName,
							packageName: metadata.package,
							iconName: getIconName(icon.name),
							categorization: metadata.categorization,
							usage: metadata.usage,
							team: metadata.team,
							status: metadata.status,
							replacement: metadata.replacement,
						} as NewCoreIconData,
					};
				})
				.reduce((acc, b) => ({ ...acc, ...b })),
		)
		.catch((error) => {
			// eslint-disable-next-line no-console
			console.error(error);
		});
};
